import React from "react";
import { FormItemProps } from "../../../interfaces/components/form";
import { useForm } from "../FormContext";
import { FormComponent } from "../FormComponents";

interface FormFieldElement extends React.ReactElement {
  props: {
    name: string;
    component?: FormComponent;
    label?: string;
    required?: boolean;
  };
}

export const FormItem: React.FC<FormItemProps> = ({
  label,
  required,
  children,
  helperText,
}) => {
  const { fields } = useForm();
  const child = React.Children.only(children) as FormFieldElement;
  const fieldName = child.props.name;
  const field = fields[fieldName];
  const errors = field?.errors || [];
  const hasErrors = errors.length > 0;
  const isCheckbox = child.props.component === FormComponent.Checkbox;

  return (
    <div className="form-item mb-4">
      {!isCheckbox && label && (
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <div className="form-control">
        {React.cloneElement(child, {
          label: isCheckbox ? label : undefined,
          required: isCheckbox ? required : undefined,
        })}
        {helperText && !hasErrors && (
          <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
            {helperText}
          </p>
        )}
        {hasErrors && (
          <div className="mt-1">
            {errors.map((error, index) => (
              <p key={index} className="text-sm text-red-600 dark:text-red-400">
                {error}
              </p>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
